module.exports = __webpack_public_path__ + "img/icon_006.02499a2.webp";